module.exports = __webpack_public_path__ + "static/media/logowhitesm.223711c5.webp";